<p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [dismissableMask]="false" [closeOnEscape]="false" [draggable]="false" [resizable]="false" header="Session Expiring Soon" [style]="{width: '28rem'}">
  <div>
    Your session is about to expire in a few minutes. Click the refresh button to extend it for the next 1 hour.
  </div>
  <ng-template pTemplate="footer">
    <button *ngIf="showCancel" pButton type="button" label="Cancel" class="p-button p-button-secondary cancel-btn" (click)="onDismiss()"></button>
    <button pButton type="button" label="Refresh" class="p-button p-button-primary refresh-button" (click)="onRefresh()"></button>
  </ng-template>
</p-dialog>
